import React from 'react';
import { IDirection } from '../logic/test-logic';
import '../styles/eye-test-input.scss';
import triangleTop from '../../../img/triangle_buttons/triangle_top.png';
import triangleTopRight from '../../../img/triangle_buttons/triangle_top_right.png';
import triangleRight from '../../../img/triangle_buttons/triangle_right.png';
import triangleBottomRight from '../../../img/triangle_buttons/triangle_bottom_right.png';
import triangleBottom from '../../../img/triangle_buttons/triangle_bottom.png';
import triangleBottomLeft from '../../../img/triangle_buttons/triangle_bottom_left.png';
import triangleLeft from '../../../img/triangle_buttons/triangle_left.png';
import triangleTopLeft from '../../../img/triangle_buttons/triangle_top_left.png';

interface Props {
    onInput: (direction: IDirection) => void
}

export const EyeTestInput: React.FunctionComponent<Props> = props => {

    return (
        <div className={'eye-test-input'}>
            <div className={"triangle triangle--top"} onClick={() => props.onInput(IDirection.TC)}>
                <img src={triangleTop} alt="Oben"/>
            </div>

            <div className={'triangle triangle--top-right'} onClick={() => props.onInput(IDirection.TR)}>
                <img src={triangleTopRight} alt="Oben rechts"/>
            </div>

            <div className={'triangle triangle--right'} onClick={() => props.onInput(IDirection.MR)}>
                <img src={triangleRight} alt="Rechts"/>
            </div>

            <div className={'triangle triangle--bottom-right'} onClick={() => props.onInput(IDirection.LR)}>
                <img src={triangleBottomRight} alt="Unten rechts"/>
            </div>

            <div className={'triangle triangle--bottom'} onClick={() => props.onInput(IDirection.LC)}>
                <img src={triangleBottom} alt="Unten"/>
            </div>

            <div className={'triangle triangle--bottom-left'} onClick={() => props.onInput(IDirection.LL)}>
                <img src={triangleBottomLeft} alt="Unten links"/>
            </div>

            <div className={'triangle triangle--left'} onClick={() => props.onInput(IDirection.ML)}>
                <img src={triangleLeft} alt="Links"/>
            </div>

            <div className={'triangle triangle--top-left'} onClick={() => props.onInput(IDirection.TL)}>
                <img src={triangleTopLeft} alt="Oben links"/>
            </div>
            <div className={'eye-test-input__landolt-wrapper'} onClick={() => props.onInput(IDirection.DONT_KNOW)}>
                {props.children}
            </div>
        </div>
    );
};
